import isArray from './isArray';
import isNull from './isNull';
import isTypeOf from './isTypeOf';
const isObject = (value) => isTypeOf('object')(value) && !isNull(value) && !isArray(value);
export default isObject;
